import React from 'react'
import './tailwind.css'
import images from '../../../editable-stuff/gitt.jpg'
// import Pdf from "../../editable-stuff/resume.pdf";
import { about } from "../../../editable-stuff/config.js";
import styles from './About.module.css'
const Abouts = () => {
    return (
        <div className=" p-8" id="aboutme">
       <h2 className="text-3xl text-center font-mono">Who's this Guy ?</h2>
        <div className="lg:container sm:w-full mx-auto">
            <div className="grid md:grid-cols-3 gap-4 mt-3 mx-auto w-full">
                <div className="col-span-1 mx-auto ">
                    <img className={styles.img} src={images} alt ="Emeke's image"/>
                </div>
                <div className="col-span-2 mt-8">                  
                    <p className="lg:ml-7 lg:pt-14 text-center text-xl">My Name is Ofuzor Chukwuemeke,I am a Front End Web Developer and Music Enthusiast and I live in Lagos State,Nigeria. I Have always been in awe of the web,I enjoy crafting amazing digital experience. I have a Knack for creating user-friendly,aesthetically pleasing functional Web Products,ranging from websites to Web-Apps.When I'm not coding you can find me vibing to Good Music 🎶 </p>                
                </div>
            </div>
        </div>
        </div>
    )
}

export default Abouts
